import { render, staticRenderFns } from "./Announces.vue?vue&type=template&id=949f4a72&scoped=true"
import script from "./Announces.vue?vue&type=script&lang=js"
export * from "./Announces.vue?vue&type=script&lang=js"
import style0 from "./Announces.vue?vue&type=style&index=0&id=949f4a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949f4a72",
  null
  
)

export default component.exports